@if (!hidden()) {
  <div
    class="alert-toast"
    [class.alert-toast--info]="severity() === 'info'"
    [class.alert-toast--warning]="severity() === 'warning'"
    [class.alert-toast--error]="severity() === 'error'"
    [class.alert-toast--success]="severity() === 'success'"
    [attr.role]="role()"
    [attr.aria-live]="live() === 'off' ? null : live()"
  >
    <img
      class="alert-toast__icon"
      [src]="iconSrc()"
      alt=""
      aria-hidden="true"
      width="16"
      height="16"
    />

    <div class="alert-toast__content">
      @if (message(); as text) {
        <p class="alert-toast__message">{{ text }}</p>
      } @else {
        <ng-content />
      }
    </div>

    @if (tooltipContent(); as tooltip) {
      <span class="visually-hidden" [id]="tooltipDescId">{{ tooltip }}</span>
      <puro-tooltip #infoTooltip [content]="tooltip">
        <button
          class="alert-toast__tooltip-trigger"
          type="button"
          [attr.aria-label]="tooltipAriaLabel()"
          [attr.aria-describedby]="tooltipDescId"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          (focus)="infoTooltip.show()"
          (blur)="infoTooltip.hide()"
        >
          <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
        </button>
      </puro-tooltip>
    } @else if (dismissible()) {
      <button
        class="alert-toast__close"
        type="button"
        [attr.aria-label]="closeAriaLabel()"
        (click)="onDismiss()"
      >
        <img
          class="alert-toast__close-icon"
          [src]="closeIconSrc()"
          alt=""
          aria-hidden="true"
          width="16"
          height="16"
        />
      </button>
    }
  </div>
}
